import { useEffect, useState } from "react";
import { Circle, Minus, Plus } from "lucide-react";

import { db } from "./firebase";
import { collection, getDocs } from "firebase/firestore";

import { Outlet, NavLink, useLocation, useNavigate } from "react-router";

const isMobileViewport = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(max-width: 768px)").matches;

const App = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [leftPanelOpen, setLeftPanelOpen] = useState(true);
  const [panelRightOpen, setPanelRightOpen] = useState(() => !isMobileViewport());
  const [terminalOpen, setTerminalOpen] = useState(() => !isMobileViewport());
  const [iframeOpacity, setIframeOpacity] = useState(0);

  const location = useLocation();
  const navigate = useNavigate();

  const handleMinimizeLeft = () => {
    setLeftPanelOpen(false);
  }

  const handleMaximizeLeft = () => {
    if (isMobileViewport()) {
      setPanelRightOpen(false);
      setTerminalOpen(false);
    }
    setLeftPanelOpen(true);
  }

  const handleMinimizeTerminal = () => {
    setTerminalOpen(false);

    if (isMobileViewport()) {
      setPanelRightOpen(false);
    }
  }

  const handleMaximizeTerminal = () => {
    setTerminalOpen(true);
    setPanelRightOpen(true);

    if (isMobileViewport()) {
      setLeftPanelOpen(false);
    }
  }

  const handleMinimizeRight = () => {
    setPanelRightOpen(false);
    setTerminalOpen(false);
  }

  const handleMaximizeRight = () => {
    setPanelRightOpen(true);

    if (isMobileViewport()) {
      setLeftPanelOpen(false);
      setTerminalOpen(false);
    } else {
      setTerminalOpen(true);
    }
  }

  useEffect(() => {
    const fetchProjects = async () => {
      const colRef = collection(db, 'projects');
      const snapshot = await getDocs(colRef);
      const projectsTmp = [];
      snapshot.docs.forEach((doc) => {
        projectsTmp.push(
          {
            id: doc.id,
            data: doc.data()
          }
        );
      });

      projectsTmp.sort((a, b) => b.data.date.seconds - a.data.date.seconds);

      if (location.pathname === "/") {
        navigate(`projects/${projectsTmp[0].id}`)
      }
      setProjects(projectsTmp);
    }

    fetchProjects();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container">
      <div className={`panel left ${leftPanelOpen ? "open" : "collapsed"}`}>
        <div className="subpanel-top">
          <label className="loading-text">{loading ? "connecting" : "127.0.0.1"}</label>
          <div className="animated-logo">
            {
              loading ?
                <div className="spinner-logo">
                  <Circle size={"1rem"} />
                </div>
                :
                <>
                  <Circle className="logo-component" size={"1rem"} />
                  <Circle className="logo-component" size={"1rem"} />
                  <Circle className="logo-component" size={"1rem"} />
                </>
            }
          </div>
        </div>
        <div className="subpanel">
          <div className="subpanel-top">
            <label>Files</label>
            <button className="min-max-button" onClick={() => leftPanelOpen ? handleMinimizeLeft() : handleMaximizeLeft()}>
              {leftPanelOpen ? <Minus size={"1rem"} /> : <Plus size={"1rem"} />}
            </button>
          </div>
          <div className="nav-container">
            {
              projects.map((project) => {
                return (
                  <NavLink
                    to={`/projects/${project.id}`}
                    className="project-tab"
                    key={project.id}
                    onClick={() => { setIframeOpacity(0); setLoading(true) }}
                  >
                    <div>{project.data.shortTitle}</div>
                    <div className="date">{new Date(project.data.date.seconds * 1000).toLocaleDateString("en-US")}</div>
                  </NavLink>
                )
              })
            }
          </div>
        </div>
      </div>
      <Outlet context={{
        projects,
        iframeOpacity,
        setIframeOpacity,
        setLoading,
        panelRightOpen,
        terminalOpen,
        handleMinimizeRight,
        handleMinimizeTerminal,
        handleMaximizeRight,
        handleMaximizeTerminal
      }} />
    </div>
  );
}

export default App;
